"use client";

import type { ReactNode } from "react";

export const RightAlignedHeader = ({ children }: { children: ReactNode }) => {
  return <div className="text-right w-full">{children}</div>;
};
